import PageMeterRead from './PageMeterRead';
import { connect } from 'react-redux';
import { AppState } from '../../interfaces';
import { setMeta } from '../../actions';
import { submitMeterRead, getMeterRead } from '../../actions/meterRead';

const mapStateToProps = (state: AppState) => ({
  listLocation: state.listLocationReducer,
  meterRead: state.meterReadReducer,
});
const mapDispatchToProps = (dispatch) => ({
  setMeta: (propertyId) => dispatch(setMeta(propertyId)),
  submitMeterRead: (propertyId, meterRead) =>
    dispatch(submitMeterRead(propertyId, meterRead)),
  getMeterRead: (propertyId) => dispatch(getMeterRead(propertyId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(PageMeterRead);
